// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1IHd0","title":"AfterFrontImage_title__16H--"};